<template>
  <div class="add">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <div class="top">
        <div class="title">应急保电</div>
        <div class="content">
          <div class="image">
            <el-upload
              class="avatar-uploader"
              :action="$uploadUrl"
              :multiple="false"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
            >
              <div class="image-area" v-if="ruleForm.pictureUrl">
                <img :src="$imgUrl + ruleForm.pictureUrl" class="avatar" />
                <span>更换</span>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="name">
            <div class="key">产品标题</div>
            <div class="value">
              <el-form-item prop="title">
                <el-input
                  type="textarea"
                  :rows="8"
                  placeholder="请输入产品标题"
                  v-model="ruleForm.title"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="price">
            <div class="item">
              <div class="key">价格/元</div>
              <div class="value">
                <el-form-item prop="emergencyPrice">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.emergencyPrice"
                  >
                    <template slot="append">
                      /天
                    </template>
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <div class="item">
              <div class="key">油费单价</div>
              <div class="value">
                <el-form-item prop="oilCost">
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="ruleForm.oilCost"
                  >
                    <template slot="append">
                      元/小时
                    </template>
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <div class="hint">
              油费说明：设备油费单独收费，不包含在服务费中，用户下单后按照用电天数单独预付每天10小时油费价格。
            </div>
          </div>
        </div>
      </div>
      <div class="info">
        <div class="title">设备信息</div>
        <div class="list">
          <div class="item">
            <div class="key">提供人姓名</div>
            <div class="value">
              <el-form-item prop="name">
                <el-input
                  type="text"
                  placeholder="请输入姓名"
                  v-model="ruleForm.name"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="item">
            <div class="key">输出电压</div>
            <div class="value">
              <el-form-item prop="voltageId">
                <el-select
                  v-model="ruleForm.voltageId"
                  placeholder="请选择设备电压"
                >
                  <el-option
                    v-for="(item, index) in voltageList"
                    :key="index"
                    :label="item.voltage"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="item">
            <div class="key">设备容量</div>
            <div class="value">
              <el-form-item prop="volumeId">
                <el-select
                  v-model="ruleForm.volumeId"
                  placeholder="请选择设备容量"
                >
                  <el-option
                    v-for="(item, index) in volumeList"
                    :key="index"
                    :label="item.volume"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="item">
            <div class="key">设备地点</div>
            <div class="value">
              <el-form-item prop="address">
                <el-cascader
                  :props="props"
                  v-model="ruleForm.address"
                  :options="regionList"
                  placeholder="请选择设备地址"
                  @change="addressChange"
                ></el-cascader>
              </el-form-item>
            </div>
          </div>
          <div class="item">
            <div class="key">设备状态</div>
            <div class="value">
              <el-select v-model="ruleForm.status" placeholder="请选择设备状态">
                <el-option label="正常" :value="0"></el-option>
                <el-option label="故障(已报修)" :value="1"></el-option>
                <el-option label="故障(未报修)" :value="2"></el-option>
                <el-option label="损坏" :value="3"></el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="key">设备类型</div>
            <div class="value">
              <el-form-item prop="typeId">
                <el-select
                  v-model="ruleForm.typeId"
                  placeholder="请选择设备类型"
                >
                  <el-option
                    v-for="(item, index) in typeList"
                    :label="item.name"
                    :value="item.id"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <div class="middle">
        <div class="item">
          <div class="title">设备详细</div>
          <div class="textarea">
            <el-form-item prop="conment">
              <el-input
                type="textarea"
                v-model="ruleForm.conment"
                :rows="7"
                placeholder="请输入设备详细介绍"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="upload">
            <el-upload
              class="avatar-uploader"
              :action="$uploadUrl"
              :multiple="false"
              :show-file-list="false"
              :on-success="handleDetailSuccess"
            >
              <div class="image-area" v-if="ruleForm.conmentUrl">
                <img :src="$imgUrl + ruleForm.conmentUrl" class="avatar" />
                <span>更换</span>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
        <div class="item">
          <div class="title">设备报告</div>
          <div class="textarea">
            <el-form-item prop="deviceReported">
              <el-input
                type="textarea"
                v-model="ruleForm.deviceReported"
                :rows="7"
                placeholder="请输入设备报告"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="upload">
            <el-upload
              class="avatar-uploader"
              :action="$uploadUrl"
              :show-file-list="false"
              :multiple="false"
              :on-success="handleReportSuccess"
            >
              <div class="image-area" v-if="ruleForm.deviceReportedUrl">
                <img
                  :src="$imgUrl + ruleForm.deviceReportedUrl"
                  class="avatar"
                />
                <span>更换</span>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="item" style="padding-left: 20px">
          <div class="title">保电方案</div>
          <div style="padding: 20px 0">
            <el-upload
              :action="$uploadUrl"
              list-type="picture-card"
              :multiple="false"
              :limit="4"
              :file-list="formatFileList(ruleForm.scheme)"
              :on-success="baodianHandleCertSuccess"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>
        <div class="item">
          <div class="title">设备证书</div>
          <div style="padding: 20px 0">
            <el-upload
              :action="$uploadUrl"
              list-type="picture-card"
              :multiple="false"
              :file-list="formatFileList(ruleForm.deviceCertificate)"
              :limit="4"
              :on-success="bookHandleCertSuccess"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="button">
        <el-button type="primary" @click="submitForm('ruleForm')">{{
          id == "" ? "立即创建" : "保存修改"
        }}</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div>
      <el-dialog :visible.sync="dialogVisible"
        ><img width="100%" :src="dialogImageUrl" alt=""
      /></el-dialog>
    </el-form>
  </div>
</template>

<script>
import {
  addEquipment,
  equipmentDetail,
  ProvinceList,
  equipmentType,
  equipmentVolumeApi,
  equipmentVoltageApi,
} from "../../http/factory/add-eme.js";
export default {
  name: "add",
  data() {
    return {
      id: "",
      uploadUrl: "",
      typeList: [],
      props: {
        label: "label",
        value: "id",
      },
      regionList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      ruleForm: {
        pictureUrl: "",
        title: "",
        emergencyPrice: "",
        oilCost: "",
        name: "",
        voltageId: 4,
        volumeId: "",
        address: "",
        status: 0,
        typeId: "",
        conment: "",
        conmentUrl: "",
        deviceReported: "",
        deviceReportedUrl: "",
        scheme: "",
        deviceCertificate: "",
        serviceType: 1,
      },
      rules: {
        title: [
          {
            required: true,
            message: "请填写产品标题",
            trigger: "blur",
          },
        ],
        emergencyPrice: [
          {
            required: true,
            message: "请填写价格",
            trigger: "blur",
          },
        ],
        oilCost: [
          {
            required: true,
            message: "请填写单价",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请填写姓名",
            trigger: "blur",
          },
        ],
        voltageId: [
          {
            required: true,
            message: "请填写电压",
            trigger: "change",
          },
        ],
        volumeId: [
          {
            required: true,
            message: "请填写设备容量",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请填写设备地点",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请填写设备状态",
            trigger: "blur",
          },
        ],
        typeId: [
          {
            required: true,
            message: "请填写设备类型",
            trigger: "blur",
          },
        ],
        conment: [
          {
            required: true,
            message: "请填写设备详细",
            trigger: "blur",
          },
        ],
        scheme: [
          {
            required: true,
            message: "请填写保电方案",
            trigger: "blur",
          },
        ],
        deviceCertificate: [
          {
            required: true,
            message: "请填写设备证书",
            trigger: "blur",
          },
        ],
        deviceReported: [
          {
            required: true,
            message: "请填写设备报告",
            trigger: "blur",
          },
        ],
      },
      volumeList: [],
      voltageList: [],
      //证书图片
      bookFileList: [],
      //保电方案图片数组
      baodianFileList: [],
    };
  },
  methods: {
    getList() {
      //设备类型列表
      equipmentType({
        serviceType: 1,
      }).then((data) => {
        this.typeList = data;
      });
      //省市区
      ProvinceList().then((data) => {
        this.regionList = data;
      });
      // 设备容量
      equipmentVolumeApi({
        serviceType: 1,
      }).then((res) => {
        this.volumeList = res;
      });
      // 设备电压
      equipmentVoltageApi({
        serviceType: 1,
      }).then((res) => {
        this.voltageList = res;
      });
    },
    //选中地址
    addressChange(value) {
      this.ruleForm.provinceId = value[0];
      this.ruleForm.cityId = value[1];
      this.ruleForm.countyId = value[2];
    },
    handleAvatarSuccess(file) {
      this.ruleForm.pictureUrl = file.fileName;
    },
    //创建设备
    submitForm(formName) {
      if (this.ruleForm.pictureUrl === "") {
        this.$message.error("请上传设备图片");
        return false;
      }
      if (this.ruleForm.conmentUrl === "") {
        this.$message.error("请上传设备详细");
        return false;
      }
      if (this.ruleForm.deviceReportedUrl === "") {
        this.$message.error("请上传设备报告");
        return false;
      }
      if (this.baodianFileList.length === 0 && !this.ruleForm.scheme) {
        this.$message.error("请上传保电方案");
        return false;
      }
      if (this.bookFileList.length === 0 && !this.ruleForm.deviceCertificate) {
        this.$message.error("请上传设备证书");
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            pictureUrl: this.ruleForm.pictureUrl,
            title: this.ruleForm.title,
            emergencyPrice: this.ruleForm.emergencyPrice,
            oilCost: this.ruleForm.oilCost,
            name: this.ruleForm.name,
            voltageId: this.ruleForm.voltageId,
            volumeId: this.ruleForm.volumeId,
            status: this.ruleForm.status,
            typeId: this.ruleForm.typeId,
            conment: this.ruleForm.conment,
            conmentUrl: this.ruleForm.conmentUrl,
            deviceReported: this.ruleForm.deviceReported,
            deviceReportedUrl: this.ruleForm.deviceReportedUrl,
            province: this.ruleForm.address[0],
            city: this.ruleForm.address[1],
            county: this.ruleForm.address[2],
            serviceType: 1,
          };
          if (this.baodianFileList.length > 0) {
            data["scheme"] = this.baodianFileList.join(",");
          }
          if (this.bookFileList.length > 0) {
            data["deviceCertificate"] = this.bookFileList.join(",");
          }
          if (this.id != "") {
            data["id"] = this.id;
          }
          addEquipment(data).then((res) => {
            this.$message({
              message: this.id == "" ? "添加设备成功" : "编辑设备成功",
              type: "success",
              duration: 2000,
              onClose: () => {
                this.$router.back();
              },
            });
          });
        }
      });
    },
    //重置
    resetForm() {
      if (this.id == "") {
        this.$refs.ruleForm.resetFields();
      } else {
        this.fetchData();
      }
    },
    fetchData() {
      equipmentDetail({
        id: this.id,
      }).then((res) => {
        this.ruleForm = {
          pictureUrl: res.pictureUrl,
          title: res.title,
          emergencyPrice: res.emergencyPrice,
          oilCost: res.oilCost,
          name: res.name,
          voltageId: res.voltageId,
          volumeId: res.volumeId,
          address: [
            parseInt(res.province),
            parseInt(res.city),
            parseInt(res.county),
          ],
          status: res.status,
          typeId: res.typeId,
          conment: res.conment,
          conmentUrl: res.conmentUrl,
          deviceReported: res.deviceReported,
          deviceReportedUrl: res.deviceReportedUrl,
          scheme: res.scheme,
          serviceType: 1,
          deviceCertificate: res.deviceCertificate,
        };
      });
    },
    handleDetailSuccess(res, file) {
      if (res.code == 200) {
        this.ruleForm.conmentUrl = res.fileName;
      }
    },
    handleReportSuccess(res, file) {
      if (res.code == 200) {
        this.ruleForm.deviceReportedUrl = res.fileName;
      }
    },
    baodianHandleCertSuccess(res, file) {
      this.baodianFileList.push(res.fileName);
    },
    bookHandleCertSuccess(res, file) {
      this.bookFileList.push(res.fileName);
    },
    formatFileList(list) {
      let arr = [];
      if (list != "") {
        for (let item of list.split(",")) {
          arr.push({
            url: this.$imgUrl + item,
          });
        }
      }
      return arr;
    },
  },
  created: function() {
    let id = this.$route.query.id;
    if (id) {
      this.id = id;
      this.fetchData();
    }
    this.getList();
  },
};
</script>

<style lang="less" scoped="scoped">
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar-uploader-icon:hover {
  border-color: #409eff;
}

.image-area {
  width: 178px;
  height: 178px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }

  span {
    width: 100%;
    height: 30px;
    position: absolute;
    left: 0px;
    bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: @vue-font-size-sm - 2;
    color: @vue-text-color-inverse;
    background: @vue-bg-color-mask;
  }
}

.add {
  width: 100%;

  .top,
  .info,
  .middle,
  .bottom {
    width: 100%;
    margin-top: @vue-spacing-col-lg;

    .title {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px @vue-spacing-row-base;
      box-sizing: border-box;
      border-bottom: 1px solid @vue-border-color;
    }
  }

  .top,
  .info,
  .bottom {
    background: @vue-bg-color;
  }

  .top {
    margin-top: 0px;

    .content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: @vue-spacing-col-base @vue-spacing-row-base;
      box-sizing: border-box;

      .name,
      .price {
        width: calc((100% - 220px) / 2);
      }

      .image {
        width: 220px;
      }

      .name {
        height: 100%;
        display: flex;
        justify-content: space-between;

        .key {
          width: 80px;
          height: 40px;
          display: flex;
          align-items: center;
          font-size: @vue-font-size-sm - 2;
          font-weight: bold;
        }

        .value {
          width: calc(100% - 80px);
          height: 100px;
        }
      }

      .price {
        padding-left: @vue-spacing-row-lg;
        box-sizing: border-box;

        .item {
          width: 100%;
          height: 60px;
          display: flex;
          justify-content: space-between;

          .key {
            width: 100px;
            font-size: @vue-font-size-sm - 2;
            color: @vue-text-color-grey;
            height: 40px;
            display: flex;
            align-items: center;
          }

          .value {
            width: calc(100% - 100px);
            padding-right: @vue-spacing-row-base;
            box-sizing: border-box;
          }
        }

        .hint {
          width: 100%;
          font-size: @vue-font-size-sm - 2;
          color: orange;
          line-height: 30px;
        }
      }
    }
  }

  .info {
    .list {
      width: 100%;
      padding: @vue-spacing-col-base @vue-spacing-row-base;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;

      .item {
        width: 33.3%;
        height: 60px;
        display: flex;
        justify-content: space-between;

        .key {
          width: 100px;
          height: 40px;
          display: flex;
          align-items: center;
          font-size: @vue-font-size-sm - 2;
          color: @vue-text-color-grey;
        }

        .value {
          width: calc(100% - 100px);
          padding-right: @vue-spacing-row-base;
          box-sizing: border-box;

          .el-select {
            width: 100%;
          }
        }
      }
    }
  }

  .middle {
    display: flex;
    justify-content: space-between;

    .item {
      width: 49%;
      background: @vue-bg-color;

      .title {
        background: @vue-bg-color;
      }

      .textarea {
        width: 100%;
        padding: @vue-spacing-col-base @vue-spacing-row-base;
        box-sizing: border-box;
      }

      .upload {
        width: 100%;
        padding: 0px @vue-spacing-col-base @vue-spacing-row-base
          @vue-spacing-col-base;
        box-sizing: border-box;
      }
    }
  }

  .bottom {
    display: flex;
    justify-content: space-between;

    .item {
      width: 50%;

      .textarea {
        width: 100%;
        padding: @vue-spacing-col-base @vue-spacing-row-base;
        box-sizing: border-box;
      }

      .hint,
      .upload {
        width: 100%;
      }

      .hint {
        line-height: 50px;
        font-size: @vue-font-size-sm - 2;
        color: orange;
      }

      .upload {
        padding-bottom: @vue-spacing-col-base;
      }
    }
  }

  .button {
    width: 100%;
    margin-top: @vue-spacing-col-lg;
    display: flex;
    justify-content: flex-end;
    padding-bottom: @vue-spacing-col-lg;
  }
}
</style>
